import {
  TbBuildingStore,
  TbCalendarEvent,
  TbCreditCard,
  TbFileImport,
  TbQrcode,
  TbRocket,
  TbUsersGroup,
} from "react-icons/tb";
import { PageSeo } from "../seo";
import { L } from "../../../../constants/baysportLabels";
import { TRIAL_DAYS } from "../../../../constants/trial";
import { LEGAL_OPERATOR } from "../../../../constants/legalDocuments";
import site from "../site.module.css";
import h from "./home.module.css";
import { FaqSection, PageHero, PhonesArt, RegisterSection, Title } from "./parts";

const STEPS = [
  [
    TbBuildingStore,
    "Создайте клуб",
    "Название, адрес клуба и аккаунт владельца — прямо на этой странице. Кабинет откроется сразу.",
    "2 минуты",
  ],
  [
    TbCalendarEvent,
    "Заведите расписание",
    "Направления, группы, залы и время занятий. Абонементы — по количеству занятий или по сроку.",
    "15–30 минут",
  ],
  [
    TbFileImport,
    "Перенесите учеников",
    "Сохраните таблицу из Excel или Google Таблиц в CSV и загрузите — ученики появятся в базе.",
    "5 минут",
  ],
  [
    TbUsersGroup,
    "Пригласите тренеров",
    "У каждого тренера свой кабинет с группами, расписанием и журналом.",
    "«Клуб» и «Про»",
  ],
  [
    TbQrcode,
    "Позовите клиентов",
    "QR-код на стойке или ссылка в чате группы — клиенты открывают приложение клуба.",
    "«Клуб» и «Про»",
  ],
  [
    TbCreditCard,
    "Подключите оплату",
    "Ключи ЮKassa или Т-Банка в настройках клуба — и абонементы можно оплачивать онлайн.",
    "«Клуб» и «Про»",
  ],
];

const FAQ = [
  [
    "Нужно ли что-то устанавливать?",
    `Нет. ${L.productName} работает в браузере на компьютере и телефоне. Клиенты открывают приложение клуба по ссылке, без App Store и Google Play.`,
  ],
  [
    "Нужен ли программист или интегратор?",
    "Нет. Всё настраивается в кабинете клуба: расписание, абонементы, тренеры и оплата. Если что-то непонятно — напишите нам, подскажем.",
  ],
  [
    "Можно ли начать с одной группы?",
    "Да. Заведите одну группу и проверьте сервис на реальных занятиях — остальные добавите, когда будете готовы.",
  ],
  [
    "Что нужно для онлайн-оплаты?",
    "Договор эквайринга с ЮKassa или Т-Банком. Ключи вводятся в настройках клуба, деньги приходят на ваш счёт. Онлайн-оплата доступна в тарифах «Клуб» и «Про».",
  ],
  [
    "Сколько длится пробный период?",
    `${TRIAL_DAYS} дней полного доступа, без привязки карты.`,
  ],
];

export default function ConnectPage() {
  return (
    <>
      <PageSeo page="connect" faq={FAQ} />

      <PageHero
        pill="Подключение CRM для клуба"
        lines={["Запуск за вечер.", "Без внедрения."]}
        lead="Не нужно ждать менеджера и проходить обучение. Регистрируете клуб сами, заводите группы и в тот же день отмечаете посещения."
        actions={
          <>
            <a href="#register" className={`${site.btn} ${site.btnLg}`}>
              Создать клуб бесплатно
            </a>
            <a href="#steps" className={h.link}>
              Шаги запуска ↗
            </a>
          </>
        }
        note={`${TRIAL_DAYS} дней полного доступа • без привязки карты`}
        visual={
          <PhonesArt
            icon={TbRocket}
            screens={["mock-owner-calendar.png", "mock-owner-journal.png"]}
          />
        }
      />

      <section className={h.section} id="steps">
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>01 / Шаги запуска</p>
            <Title lines={["Шесть шагов —", "и клуб работает"]} />
            <p className={h.sub}>
              Первые три шага — основа, они есть во всех тарифах. Остальные
              добавляете, когда понадобятся.
            </p>
          </div>
          <ol className={h.launch}>
            {STEPS.map(([Icon, t, d, time], i) => (
              <li key={t} className={h.card}>
                <span className={h.launchTop}>
                  <span className={`${h.audIcon} ${h.principleIcon}`} aria-hidden>
                    <Icon size={22} />
                  </span>
                  <em>{String(i + 1).padStart(2, "0")}</em>
                </span>
                <h3>{t}</h3>
                <p>{d}</p>
                <span className={h.planTag}>{time}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <RegisterSection
        kicker="02 / Регистрация"
        title={["Начните с первого шага", "прямо сейчас"]}
        soft
      />

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.ask}>
            <div>
              <h3>Поможем с запуском</h3>
              <p>
                Перенос базы, настройка абонементов или подключение оплаты —
                напишите, и мы подскажем, как сделать это быстрее.
              </p>
            </div>
            <a href={`mailto:${LEGAL_OPERATOR.supportEmail}`} className={site.btn}>
              {LEGAL_OPERATOR.supportEmail}
            </a>
          </div>
        </div>
      </section>

      <FaqSection kicker="03 / Вопросы и ответы" items={FAQ} soft />
    </>
  );
}
